function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import FormContainerAbstract from 'components/FormContainerAbstract';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input from 'components/Form/Input';
import Select from 'components/Form/Select';
import Loupe from 'svg/loupe.svg';
import App from 'modules/App';
import * as constants from '../../constants';
import messages from '../../messages';
import styles from './Join.pcss';
class Filters extends FormContainerAbstract {
    get countryOptions() {
        return this.props.countryCodes.map((countryCode)=>{
            const country = this.props.countries.find((c)=>c.alpha2Code === countryCode);
            return {
                value: country.alpha2Code,
                label: get(this.props.localizationResources, [
                    country.nameKey,
                    'value'
                ], country.englishName)
            };
        }).sort((a, b)=>a.label.localeCompare(b.label));
    }
    onSetValue(input) {
        super.onSetValue(input);
        this.props.onSetFilter({
            [input.id]: input.value.trim()
        });
    }
    renderCountry() {
        if (this.props.countryCodes.length === 1) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "col-4",
            children: /*#__PURE__*/ _jsx(FormGroup, {
                id: "countryCode",
                labelMessage: App.messages.labels.country,
                formValues: this.props.formValues,
                children: /*#__PURE__*/ _jsx(Select, {
                    optionsFrom: this.countryOptions,
                    valueKey: "value",
                    labelKey: "label",
                    onChange: (input)=>this.onSetValue(input)
                })
            })
        });
    }
    renderSearch() {
        const colParam = this.props.countryCodes.length === 1 ? 12 : 8;
        return /*#__PURE__*/ _jsxs("div", {
            className: `col-${colParam}`,
            children: [
                /*#__PURE__*/ _jsx(FormGroup, {
                    id: "term",
                    labelMessage: messages.labels.searchOrganization,
                    formValues: this.props.formValues,
                    className: "mb-0",
                    children: /*#__PURE__*/ _jsx(Input, {
                        placeholder: messages.placeholders.searchOrganization,
                        onChange: (input)=>this.onSetValue(input)
                    })
                }),
                /*#__PURE__*/ _jsx(Loupe, {
                    className: styles.search__loupe
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(Form, {
            className: "row mb-3",
            children: [
                this.renderSearch(),
                this.renderCountry()
            ]
        });
    }
    constructor(props){
        super(props);
        const countryCode = get(props.formValues, 'values.countryCode');
        if (!countryCode && props.defaultCountryCode) {
            props.onSetFormValues({
                countryCode: props.defaultCountryCode
            });
        }
    }
}
_define_property(Filters, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit props
    countryCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
    defaultCountryCode: PropTypes.string,
    // Explicit props
    onSetFilter: PropTypes.func.isRequired,
    // Implicit props
    countries: PropTypes.arrayOf(App.shapes.country),
    localizationResources: PropTypes.object,
    // Implicit actions
    onSetFormValue: PropTypes.func,
    onSetFormValues: PropTypes.func
}));
_define_property(Filters, "defaultProps", {
    defaultCountryCode: null
});
const mapStateToProps = (state)=>({
        countries: App.selectors.countries(state),
        formValues: App.selectors.formSelector(constants.SEARCH_ORGANIZATION_FORM)(state),
        localizationResources: App.selectors.localizationResources(state)
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.SEARCH_ORGANIZATION_FORM;
    return {
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedFilters = connect(mapStateToProps, mapDispatchToProps)(Filters);
export default ConnectedFilters;
